export default __webpack_public_path__ + "static/media/4525.5301be94.png";